import { Navigate, useRoutes } from "react-router-dom";
import Layout from "../../components/Layout";
import EditCustomer from "../../modules/Customers/pages/EditCustomer";
import { Orders } from "../../modules/Orders";
import Success from "../../modules/licensees/pages/Success";
import Payment from "../../modules/licensees/pages/Payment";
import Problem from "../../modules/licensees/pages/Problem";
import LayoutIframe from "../../components/LayoutIframe";
import { InDevelopment } from "../../modules/InDevelopment";
import { CreateOrder } from "../../modules/Orders/CreateOrder";
import { useAuth } from "../../hooks/AuthContext";
import { SolutionsCategory } from "../../modules/Fixiter/pages/SolutionsCategory";
import BracingTypes from "../../modules/licensees/pages/BracingTypes";
import Solutions from "../../modules/Orders/Solutions";
import Address from "../../modules/Fixiter/pages/Address";
import Users from "../../modules/Fixiter/pages/UsersList";
import { Dashboard } from "../../modules/Dashboard";
import { useOnboard } from "../../hooks/OnboardContext";
import PlanExpired from "../../modules/Fixiter/pages/PlanExpired";
import Logon from "../../modules/Logon";
import { Financial } from "../../modules/Financial";
import { PaymentGuardLayout } from "../../components/PaymentGuardLayout";
import Courses from "../../modules/Fixiter/pages/Courses";
import Certificate from "../../modules/Fixiter/pages/Certificate";
import { roles } from "../../utils/constants";
import { Loading } from "../../components/Loading";


function LicenseesRoutes() {
  const { user } = useAuth();
  const {
    licensee,
    planHasExpired,
    isSubscriptionBlocked,
    isSubscriptionCancelled,
    loadingLicensee,
  } = useOnboard();

  const licenseBlockedRoutes = useRoutes([
    { path: "/", element: <Logon /> },
    {
      path: "/payment",
      element: (
        <LayoutIframe>
          <Payment />
        </LayoutIframe>
      ),
    },
    {
      path: "/dashboard",
      element: (
        <LayoutIframe>
          <PlanExpired />
        </LayoutIframe>
      ),
    },
    {
      path: "*",
      element: (
        <LayoutIframe>
          <PlanExpired />
        </LayoutIframe>
      ),
    },
  ]);

  const licenseeRoutes = useRoutes([
    { path: "/", element: <Logon /> },
    {
      element: <PaymentGuardLayout />,
      children: [
        {
          path: "/solutions",
          element: (
            <Layout>
              <SolutionsCategory />
            </Layout>
          ),
        },
        {
          path: "/categories/:field_key",
          element: (
            <Layout>
              <BracingTypes />
            </Layout>
          ),
        },
        {
          path: "/solutions/:category_key",
          element: (
            <Layout>
              <Solutions />
            </Layout>
          ),
        },
        {
          path: "/order/:solution_key/:solution_type",
          element: (
            <Layout>
              <CreateOrder />
            </Layout>
          ),
        },
        {
          path: "/order/:solution_key/:solution_type/:size",
          element: (
            <Layout>
              <CreateOrder />
            </Layout>
          ),
        },
        {
          path: "/dashboard",
          element: (
            <Layout>
              <Dashboard />
            </Layout>
          ),
        },
        {
          path: "/profile",
          element: (
            <Layout>
              <EditCustomer isSelfProfile />
            </Layout>
          ),
        },
        {
          path: "/orders",
          element: (
            <Layout>
              <Orders />
            </Layout>
          ),
        },
        {
          path: "/orders/:as_provider",
          element: (
            <Layout>
              <Orders />
            </Layout>
          ),
        },
        {
          path: "/licensee/orders/:closure",
          element: (
            <Layout>
              <Orders />
            </Layout>
          ),
        },
        {
          path: "/financial",
          element: (
            <Layout>
              <Financial />
            </Layout>
          ),
        },
        {
          path: "/financial/reports",
          element: (
            <Layout>
              <Financial initialTab={0} />
            </Layout>
          ),
        },
        {
          path: "/financial/bills",
          element: (
            <Layout>
              <Financial initialTab={1} />
            </Layout>
          ),
        },
        {
          path: "/financial/transactions",
          element: (
            <Layout>
              <Financial initialTab={2} />
            </Layout>
          ),
        },
        {
          path: "/problem",
          element: (
            <Layout>
              <Problem />
            </Layout>
          ),
        },
        {
          path: "/success",
          element: (
            <Layout noPadding>
              <Success />
            </Layout>
          ),
        },
        {
          path: "/licensee/address",
          element: (
            <Layout>
              <Address />
            </Layout>
          ),
        },
        {
          path: "/licensee/my-users",
          element: (
            <Layout>
              <Users />
            </Layout>
          ),
        },
        {
          path: "/licensee/profile",
          element: (
            <Layout>
              <EditCustomer isSelfProfile />
            </Layout>
          ),
        },
        {
          path: "/development",
          element: (
            <Layout>
              <InDevelopment />
            </Layout>
          ),
        },
        {
          path: "/licensee/profile/:options",
          element: (
            <Layout>
              <EditCustomer isSelfProfile />
            </Layout>
          ),
        },
        {
          path: "/profile/:options",
          element: (
            <Layout>
              <EditCustomer isSelfProfile />
            </Layout>
          ),
        },
        {
          path: "/courses",
          element: (
            <Layout>
              <Courses />
            </Layout>
          ),
        },
        {
          path: "/certificate",
          element: (
            <Layout>
              <Certificate />
            </Layout>
          ),
        },
        {
          path: "/onboard",
          element: <Navigate to="/dashboard" replace />,
        },
      ],
    },
  ]);

  if (
    user?.role === roles.admin ||
    user?.role === roles.creator
  ) {
    return null;
  }

  if (
    loadingLicensee &&
    !licensee &&
    !user?.person?.licensee &&
    !(user as any)?.licensee
  ) {
    return <Loading loading={true} />;
  }

  if (
    user?.person?.licensee?.is_blocked === true ||
    isSubscriptionBlocked === true ||
    isSubscriptionCancelled === true ||
    planHasExpired === true
  ) {
    return licenseBlockedRoutes;
  }

  return licenseeRoutes;
}

export default LicenseesRoutes;
